export default __webpack_public_path__ + "static/media/640_dummy2016-grafikdesigner01-de.e9435e06.png";